import React from 'react'
import { Alert, Flex, Spin, Modal, Form } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import questionSelectors from '../../../../../store/selectors/question.selectors'
import { useFetchQuestionsQuery } from '../../../../../store/apis/question.api'
import { fetchQuestionsSelectors } from '../../../../../store/apis/utils/selectors/question.api.selectors'
import { useParams } from 'react-router'
import { questionActions } from '../../../../../store/slices/question.slice'
import EditQuestionForm from './EditQuestionForm'
import ResizableDrawer from '../../../../../components/common/resizable-drawer/ResizableDrawer'
import CategoriesList from '../category/CategoriesList'
import { isNumber } from 'lodash'
import EditCategoryDrawer from '../category/edit/EditCategoryDrawer'
import CreateCategoryDrawer from '../category/create/CreateCategoryDrawer'
import { useVersionId } from '../../../../../utils/parseURL.helper'
import ChangesHistoryButton from './changes-history/ChangesHistoryButton'

const QuestionDrawer = () => {
    const editingQuestionId = useSelector(questionSelectors.editingQuestionId)
    const editingCategoryId = useSelector(questionSelectors.editingCategoryId)
    const showCreateCategoryDrawer = useSelector(questionSelectors.showCreateCategoryDrawer)
    const dispatch = useDispatch()
    const { token } = useParams()
    const versionId = useVersionId()
    const [form] = Form.useForm()

    const {
        data: question,
        isFetching,
        error,
    } = useFetchQuestionsQuery(
        { token, versionId },
        {
            selectFromResult: result => fetchQuestionsSelectors.byId({ id: editingQuestionId }, result),
        },
    )

    const handleClose = () => {
        if (form.isFieldsTouched()) {
            Modal.confirm({
                title: 'Unsaved Changes',
                content: 'You have unsaved changes. Are you sure you want to close?',
                okText: 'Yes, close',
                cancelText: 'No, keep editing',
                onOk() {
                    dispatch(questionActions.setEditingQuestionId(null))
                },
            })
        } else {
            dispatch(questionActions.setEditingQuestionId(null))
        }
    }

    const content = (
        <Flex vertical>
            <EditQuestionForm form={form} />
            {!question?.children && <CategoriesList categories={question?.categories} />}{' '}
            {isNumber(editingCategoryId) && <EditCategoryDrawer />}
            {showCreateCategoryDrawer && <CreateCategoryDrawer />}
        </Flex>
    )

    return (
        <ResizableDrawer
            title='Edit question'
            open
            autoFocus
            onClose={handleClose}
            mask={null}
            extra={<ChangesHistoryButton />}
        >
            <Spin spinning={isFetching} tip='Loading question...'>
                {error ? <Alert message={error} type='error' showIcon /> : content}
            </Spin>
        </ResizableDrawer>
    )
}

export default QuestionDrawer
